/* ==========================================================================
   Accessibility (WCAG 2.1 AA) — peltzshoes.com remediation
   ========================================================================== */

(function() {
  'use strict';

  /* ------------------------------------------------------------------
     A11y announcement helpers (62j)
     ------------------------------------------------------------------ */
  var A11y = {
    announce: function(message) {
      var el = document.getElementById('a11y-status');
      if (!el) return;
      el.textContent = '';
      setTimeout(function() { el.textContent = message; }, 100);
    },
    alert: function(message) {
      var el = document.getElementById('a11y-alert');
      if (!el) return;
      el.textContent = '';
      setTimeout(function() { el.textContent = message; }, 100);
    }
  };
  window.A11y = A11y;

  /* ------------------------------------------------------------------
     Accessible Dialog / Focus Trap (62f)
     ------------------------------------------------------------------ */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function AccessibleDialog(dialogEl, triggerEl) {
    this.dialog = dialogEl;
    this.trigger = triggerEl;
    this.previousFocus = null;
    this._onKeydown = this._handleKeydown.bind(this);
  }

  AccessibleDialog.prototype.open = function() {
    this.previousFocus = document.activeElement;

    if (!this.dialog.getAttribute('role')) {
      this.dialog.setAttribute('role', 'dialog');
    }
    this.dialog.setAttribute('aria-modal', 'true');

    // Focus close button or first focusable
    var self = this;
    setTimeout(function() {
      var closeBtn = self.dialog.querySelector('.drawer-close, [data-dialog-close]');
      var focusable = self.dialog.querySelectorAll(FOCUSABLE);
      if (closeBtn) {
        closeBtn.focus();
      } else if (focusable.length) {
        focusable[0].focus();
      }
    }, 150);

    this.dialog.addEventListener('keydown', this._onKeydown);

    // Hide background from screen readers
    var siblings = document.body.children;
    for (var i = 0; i < siblings.length; i++) {
      var sib = siblings[i];
      if (sib !== this.dialog && !sib.contains(this.dialog) && !this.dialog.contains(sib) && sib.tagName !== 'SCRIPT' && sib.tagName !== 'LINK') {
        if (!sib.hasAttribute('aria-hidden')) {
          sib.setAttribute('aria-hidden', 'true');
          sib.setAttribute('data-a11y-hidden', 'true');
        }
      }
    }
  };

  AccessibleDialog.prototype.close = function() {
    this.dialog.removeAttribute('aria-modal');
    this.dialog.removeEventListener('keydown', this._onKeydown);

    // Restore background
    var hidden = document.querySelectorAll('[data-a11y-hidden]');
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].removeAttribute('aria-hidden');
      hidden[i].removeAttribute('data-a11y-hidden');
    }

    // Return focus to trigger
    if (this.previousFocus && this.previousFocus.focus) {
      this.previousFocus.focus();
    }
  };

  AccessibleDialog.prototype._handleKeydown = function(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      window.closeAllDrawers(function() {});
      return;
    }

    if (e.key !== 'Tab') return;

    var focusable = Array.prototype.slice.call(this.dialog.querySelectorAll(FOCUSABLE));
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  window.AccessibleDialog = AccessibleDialog;

  /* ------------------------------------------------------------------
     Hook into existing drawer open/close functions (62f)
     ------------------------------------------------------------------ */
  var activeDialogs = {};

  function hookDrawer(openFnName, drawerId, label) {
    var originalOpen = window[openFnName];
    if (!originalOpen) return;

    window[openFnName] = function() {
      originalOpen.apply(this, arguments);
      var drawer = document.getElementById(drawerId);
      if (drawer) {
        if (!drawer.getAttribute('aria-label')) {
          drawer.setAttribute('aria-label', label);
        }
        var dialog = new AccessibleDialog(drawer, document.activeElement);
        dialog.open();
        activeDialogs[drawerId] = dialog;
      }
    };
  }

  document.addEventListener('DOMContentLoaded', function() {
    hookDrawer('openCartDrawer', 'drawer-cart', 'Shopping cart');
    hookDrawer('openFiltersDrawer', 'drawer-filters', 'Filters');
    hookDrawer('openSearchDrawer', 'drawer-search', 'Search');

    // Hook into mobile drawer
    var mobileDrawer = document.querySelector('.drawer-mobile');
    if (mobileDrawer && !mobileDrawer.id) {
      mobileDrawer.id = 'drawer-mobile';
    }
    hookDrawer('openMobileDrawer', 'drawer-mobile', 'Mobile navigation');
    hookDrawer('openSizeGuideDrawer', 'drawer-size-guide', 'Size guide');

    // Hook closeAllDrawers to clean up focus traps
    var originalClose = window.closeAllDrawers;
    if (originalClose) {
      window.closeAllDrawers = function(callback) {
        for (var id in activeDialogs) {
          if (activeDialogs[id]) {
            activeDialogs[id].close();
          }
        }
        activeDialogs = {};
        originalClose(callback);
      };
    }
  });

  /* ------------------------------------------------------------------
     Desktop menu keyboard navigation (62c, 62e)
     ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function() {
    var menuItems = document.querySelectorAll('.menu-desktop > .menu-desktop__item');
    if (!menuItems.length) return;

    // Add ARIA attributes to menu items with children
    menuItems.forEach(function(item) {
      var link = item.querySelector('.menu-desktop__link');
      var submenu = item.querySelector('.menu-desktop__mega, .menu-desktop__drop');

      if (link && submenu) {
        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-haspopup', 'true');

        // Keyboard handler for top-level menu items
        link.addEventListener('keydown', function(e) {
          var subLinks = submenu.querySelectorAll('.menu-child__link, .menu-child__title, .menu-mega__title, .menu-grandchild__link');
          var allTopLinks = Array.prototype.slice.call(document.querySelectorAll('.menu-desktop > .menu-desktop__item > .menu-desktop__link'));
          var currentIndex = allTopLinks.indexOf(link);

          switch (e.key) {
            case 'Enter':
            case ' ':
              if (submenu) {
                var isOpen = item.classList.contains('active');
                if (!isOpen) {
                  e.preventDefault();
                  // Close all menus first
                  menuItems.forEach(function(mi) {
                    mi.classList.remove('active');
                    var ml = mi.querySelector('.menu-desktop__link');
                    if (ml) ml.setAttribute('aria-expanded', 'false');
                  });
                  item.classList.add('active');
                  document.body.classList.add('mega-open');
                  link.setAttribute('aria-expanded', 'true');
                  if (subLinks.length) subLinks[0].focus();
                }
                // If already open, let the default link navigation happen (don't preventDefault)
              }
              break;

            case 'ArrowDown':
              e.preventDefault();
              item.classList.add('active');
              document.body.classList.add('mega-open');
              link.setAttribute('aria-expanded', 'true');
              if (subLinks.length) subLinks[0].focus();
              break;

            case 'ArrowRight':
              e.preventDefault();
              if (currentIndex < allTopLinks.length - 1) {
                allTopLinks[currentIndex + 1].focus();
              }
              break;

            case 'ArrowLeft':
              e.preventDefault();
              if (currentIndex > 0) {
                allTopLinks[currentIndex - 1].focus();
              }
              break;

            case 'Escape':
              e.preventDefault();
              item.classList.remove('active');
              document.body.classList.remove('mega-open');
              link.setAttribute('aria-expanded', 'false');
              link.focus();
              break;
          }
        });

        // Keyboard navigation within submenus
        submenu.addEventListener('keydown', function(e) {
          var subLinks = Array.prototype.slice.call(submenu.querySelectorAll('.menu-child__link, .menu-child__title, .menu-mega__title, .menu-grandchild__link'));
          var currentIdx = subLinks.indexOf(document.activeElement);

          switch (e.key) {
            case 'ArrowDown':
              e.preventDefault();
              if (currentIdx < subLinks.length - 1) {
                subLinks[currentIdx + 1].focus();
              }
              break;

            case 'ArrowUp':
              e.preventDefault();
              if (currentIdx > 0) {
                subLinks[currentIdx - 1].focus();
              } else {
                link.focus();
              }
              break;

            case 'Escape':
              e.preventDefault();
              item.classList.remove('active');
              document.body.classList.remove('mega-open');
              link.setAttribute('aria-expanded', 'false');
              link.focus();
              break;

            case 'Tab':
              // Close menu when tabbing out
              item.classList.remove('active');
              document.body.classList.remove('mega-open');
              link.setAttribute('aria-expanded', 'false');
              break;
          }
        });
      }
    });
  });

  /* ------------------------------------------------------------------
     Variant selection error announcements (62j)
     ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function() {
    // Hook into getSelectedVariants to announce errors
    var origGetSelectedVariants = window.getSelectedVariants;
    if (origGetSelectedVariants) {
      window.getSelectedVariants = function(form, callback) {
        origGetSelectedVariants(form, function(result) {
          if (result[0] === 'none') {
            A11y.alert('Please select all options before adding to cart.');
          } else if (result[0] === 'unavailable') {
            A11y.alert('Sorry, this combination is currently sold out.');
          }
          callback(result);
        });
      };
    }
  });

  /* ------------------------------------------------------------------
     Cart announcements (62j)
     ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function() {
    // Intercept cart add for announcements
    var origFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      var result = origFetch.apply(this, args);

      if (url.indexOf('/cart/add.js') !== -1) {
        result.then(function(res) {
          var cloned = res.clone();
          cloned.json().then(function(data) {
            if (data && data.title) {
              A11y.announce(data.title + ' added to your cart.');
            } else if (data && data.description) {
              A11y.alert(data.description);
            }
          }).catch(function() {});
        });
      }

      if (url.indexOf('/cart/change.js') !== -1 || url.indexOf('/cart/update.js') !== -1) {
        result.then(function(res) {
          var cloned = res.clone();
          cloned.json().then(function(data) {
            if (data && data.item_count !== undefined) {
              A11y.announce('Cart updated. ' + data.item_count + ' items in your cart.');
            }
          }).catch(function() {});
        });
      }

      return result;
    };
  });

  /* ------------------------------------------------------------------
     Collection filter focus management (62i)
     ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function() {
    if (window.location.search.indexOf('filter') !== -1 || window.location.search.indexOf('sort_by') !== -1) {
      var grid = document.querySelector('ul.products, .product-grid, .collection-products, .main-collection');
      if (grid) {
        grid.setAttribute('tabindex', '-1');
        grid.focus();
        var cards = grid.querySelectorAll('.card-product');
        A11y.announce('Filter applied. Showing ' + cards.length + ' products.');
      }
    }
  });

  /* ------------------------------------------------------------------
     PDP: Focus variant section after color-link navigation
     When a user clicks a color swatch (which is an <a> link to another
     product), the page reloads. Detect referrer from same site + product
     page and auto-focus the variants section so keyboard/SR users don't
     have to tab through the entire page again.
     ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function() {
    var isProductPage = document.querySelector('.section-product__details__variants');
    if (!isProductPage) return;

    // Check if user came from another product page (color swatch navigation)
    var ref = document.referrer;
    if (ref && ref.indexOf(window.location.host) !== -1 && ref.indexOf('/products/') !== -1) {
      var variants = document.querySelector('.section-product__details__variants');
      if (variants) {
        variants.setAttribute('tabindex', '-1');
        setTimeout(function() {
          variants.focus({ preventScroll: false });
          variants.scrollIntoView({ behavior: 'smooth', block: 'center' });
          A11y.announce('Color changed. Select your size.');
        }, 300);
      }
    }
  });

  /* ------------------------------------------------------------------
     Carousel pause on reduced-motion (62g)
     ------------------------------------------------------------------ */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.swiper').forEach(function(el) {
        if (el.swiperInstance) el.swiperInstance.autoplay.stop();
      });
    });
  }

})();
